'use client';

import React from 'react';
import SlidePanel from './LiteSlidePanel';
import SliderNavigation from './LiteSliderNavigation';
import SliderPagination from './LiteSliderPagination';
import useSlider from './useLiteSlider';
import './LiteSlider.style.scss';

interface SliderProps {
  tag?: 'div' | 'ul';
  slides: React.ReactNode[];
  type?: 'slide' | 'fade';
  isOverlap?: boolean;
  autoplay?: boolean;
  duration?: number;
  delay?: number;
  pagination?: boolean;
  navigation?: boolean;
  className?: string;
}

const LiteSlider: React.FC<SliderProps> = ({
  tag = 'div',
  slides,
  type = 'fade', // 기본 타입: fade
  autoplay = false,
  delay,
  duration,
  pagination = true,
  navigation = true,
  className,
  isOverlap = false,
}) => {
  const Tag = tag as keyof JSX.IntrinsicElements;
  const { currentIndex, slideTo, nextSlide, prevSlide, startAutoplay, stopAutoplay, sliderRef } =
    useSlider({
      totalSlides: slides.length,
      autoplay,
      delay,
      type,
      isOverlap,
    });
  let containerClassName = `liteSlider liteSlider--type-${type}`;
  if (className) containerClassName += ` ${className}`;
  if (type === 'slide' && isOverlap) containerClassName += ` overlap`;
  if (sliderRef.current && sliderRef.current.parentElement) {
    if (duration) {
      sliderRef.current.parentElement.style.setProperty(
        '--panel-duration-time',
        `${duration / 1000}s`,
      );
    }
  }

  return (
    <div
      ref={sliderRef}
      className={containerClassName}
      onMouseEnter={stopAutoplay}
      onMouseLeave={startAutoplay}
    >
      <Tag className={'liteSlider__content'}>
        {slides.map((slide, index) => (
          <SlidePanel
            tag={tag === 'ul' ? 'li' : 'div'}
            key={index}
            isActive={index === currentIndex}
            onMouseEnter={stopAutoplay}
            onMouseLeave={startAutoplay}
          >
            {slide}
          </SlidePanel>
        ))}
      </Tag>
      {pagination && (
        <SliderPagination
          totalSlides={slides.length}
          currentIndex={currentIndex}
          onClick={slideTo}
        />
      )}
      {navigation && <SliderNavigation onPrevClick={prevSlide} onNextClick={nextSlide} />}
    </div>
  );
};

export default LiteSlider;
